import { simStateConfig, simulationConfig } from "./simulation";

// Validation limits in packages/sim/src/features/protection.ts
export const simFeaturesProtectionLimits = {
  ProtectionCommandSchema_radius_minimum: 64,
  ProtectionCommandSchema_radius_maximum: 640,
};

// Validation limits in packages/sim/src/features/cohorts.ts
export const simFeaturesCohortsLimits = {
  Id_maximum: 1_000_000_000,
  PointSchema_x_maximum: 1_000_000,
  PointSchema_y_maximum: 1_000_000,
  CohortSchema_team_maximum: simStateConfig.MAX_TEAMS - 1,
  CohortSchema_members_minItems: 2,
  CohortSchema_members_maxItems: 256,
};

// Validation limits in packages/sim/src/features/alliances.ts
export const simFeaturesAlliancesLimits = {
  outcomePointSchema_maximum: 1_000_000_000,
};

// Validation limits in packages/sim/src/features/patrol.ts
export const simFeaturesPatrolLimits = {
  PatrolSnapshotPointsSchema_minItems: 2,
  PatrolStateSchema_points_minItems: 2,
};

// Validation limits in packages/sim/src/feature-registry.ts
export const simFeatureRegistryLimits = {
  featureSerializedSchema_cohorts_maxItems: 1024,
  featureSerializedSchema_battleEvents_maxItems: 256,
  featureSerializedSchema_nextCohortId_maximum: 1_000_000_001,
};

// Validation limits in packages/sim/src/snapshot.ts
export const simSnapshotLimits = {
  SnapshotHeaderSchema_nextOrderId_maximum: 1_000_000_001,
  SnapshotEntitySchema_facing_maximum: 15,
  SnapshotEntitySchema_capturing_elapsed_maximum: 3600,
  SnapshotEntitySchema_passengers_maxItems: 150,
  SnapshotPathBudgetsSchema_maximum: 64,
  SnapshotVisibilityCellSchema_maximum: 2,
  SnapshotCoreSchema_strikeReveals_maxItems: 4096,
};

// Validation limits in packages/sim/src/view-schema.ts
export const simViewSchemaLimits = {
  ViewTickSchema_maximum: 1e9,
  ViewFogValueSchema_maximum: 2,
  ViewEntityBaseSchema_facing_maximum: 15,
  ViewEntityBaseSchema_flightHeight_maximum: simulationConfig.aircraftAltitude,
  ViewEffectStrikeSchema_radius_maximum: 8192,
  ViewQueueJobElapsedSchema_maximum: 3_600,
  ViewQueueSchema_maxItems: 20,
  ViewTravelSchema_id_maximum: 1_000_000_000,
  ViewTravelSchema_count_minimum: 2,
  ViewTravelSchema_count_maximum: 256,
  OwnFieldsSchema_capturing_owner_maximum: simStateConfig.MAX_TEAMS - 1,
  OwnFieldsSchema_capturing_elapsed_maximum: 3600,
  OwnFieldsSchema_passengers_maxItems: 150,
  OwnFieldsSchema_upgrades_maxItems: 16,
  WorldViewSchema_missileStrikes_maxItems: 4096,
};

// Validation limits in packages/sim/src/command-schema.ts
export const simCommandSchemaLimits = {
  CoreCommandOpSchema_entries_entryId_maximum: 1_000_000_000,
  CoreCommandOpSchema_entries_intentId_maximum: 1_000_000_000,
};

// Validation limits in packages/sim/src/formations.ts
export const simFormationsLimits = {
  FormationFacingSchema_maximum: 15,
  cohortId_maximum: 1_000_000_000,
};

// Validation limits in packages/sim/src/core-schema.ts
export const simCoreSchemaLimits = {
  identity_entryId_maximum: 1_000_000_000,
  identity_intentId_maximum: 1_000_000_000,
  protection_radius_minimum: 64,
  protection_radius_maximum: 640,
  protection_offsetX_minimum: -640,
  protection_offsetX_maximum: 640,
  protection_offsetY_minimum: -640,
  protection_offsetY_maximum: 640,
  MissileInventorySchema_remaining_maximum: 3600,
  MissileInventorySchema_cost_maximum: 1000000,
  StrikeRevealSchema_team_maximum: simStateConfig.MAX_TEAMS - 1,
  StrikeRevealSchema_radius_maximum: 8192,
  StrikeRevealSchema_remaining_maximum: 3600,
  FlightSchema_home_maximum: 1000000000,
  FlightSchema_slot_maximum: 149,
  FlightSchema_remaining_maximum: 3600,
  FlightSchema_height_maximum: simulationConfig.aircraftAltitude,
};
